/**
 * This function generates the value of a grid-template-columns attribute that supports transitions.
 *
 * When using CSS transitions to add a column in a grid, for example from 1f to 1f 1f, the transition won't run properly.
 * You instead need to transition from 1f 0f to 1f 1f, which allows CSS transitions to know how many columns are changing between the transition.
 *
 * This function easily generates the value based on the total number of columns, and optionally how many columns should be visible.
 *
 * For example:
 * 5 visible columns: generateAnimatableGridTemplateColumns(5) ⭢ 1f 1f 1f 1f 1f
 * 5 columns, only 3 should be visible: generateAnimatableGridTemplateColumns(5, 3) ⭢ 1f 1f 1f 0f 0f
 */
export function generateAnimatableGridTemplateColumns(
  total: number,
  visible = total,
) {
  if (visible > total) {
    return ""
  }

  return [
    ...new Array(visible).fill("1fr"),
    ...new Array(total - visible).fill("0fr"),
  ].join(" ")
}
